// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableRows_root_qWzzX {
  color: black;
}

.tableRows_root_qWzzX > * {
  margin: 0 calc(-1 * var(--border-radius));
  padding: 0 calc(var(--border-radius) * 0.5) 0 var(--border-radius);
}

.tableRows_root_qWzzX > *:nth-child(odd) {
  background-color: var(--timetable-accent-color);
}

/* Used inside the interval timetable right panel where the container is already inset */
.tableRows_root_qWzzX.tableRows_inset_kHSAz > * {
  margin: 0 calc(-0.5 * var(--border-radius));
  padding: 0 calc(var(--border-radius) * 0.5);
}

.tableRows_a3root_tgiue {
  margin: 0px;
  padding: 0px;
  color: black;
}

.tableRows_a3root_tgiue > *:nth-child(odd) {
  background-color: var(--timetable-accent-color);
}

.tableRows_item_Wga4R {
  display: flex;
  min-width: 3.75em;
  padding: 0.25em 0;
  font-family: GothamXNarrow-Book;
  font-size: 15px;
  letter-spacing: -0.025em;
  line-height: 1;
  margin-right: 0.25em;
}

.tableRows_minutes_OYTai {
  min-width: 0.75em;
  font-family: GothamXNarrow-Medium;
}

.tableRows_hours_ZTGuY {
  padding-left: 0.938em;
  font-family: GothamXNarrow-Medium;
}

.tableRows_compactRow__moSu {
  font-size: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/timetable/tableRows.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,kEAAkE;AACpE;;AAEA;EACE,+CAA+C;AACjD;;AAEA,wFAAwF;AACxF;EACE,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,wBAAwB;EACxB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EAEE,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".root {\n  color: black;\n}\n\n.root > * {\n  margin: 0 calc(-1 * var(--border-radius));\n  padding: 0 calc(var(--border-radius) * 0.5) 0 var(--border-radius);\n}\n\n.root > *:nth-child(odd) {\n  background-color: var(--timetable-accent-color);\n}\n\n/* Used inside the interval timetable right panel where the container is already inset */\n.root.inset > * {\n  margin: 0 calc(-0.5 * var(--border-radius));\n  padding: 0 calc(var(--border-radius) * 0.5);\n}\n\n.a3root {\n  margin: 0px;\n  padding: 0px;\n  color: black;\n}\n\n.a3root > *:nth-child(odd) {\n  background-color: var(--timetable-accent-color);\n}\n\n.item {\n  display: flex;\n  min-width: 3.75em;\n  padding: 0.25em 0;\n  font-family: GothamXNarrow-Book;\n  font-size: 15px;\n  letter-spacing: -0.025em;\n  line-height: 1;\n  margin-right: 0.25em;\n}\n\n.minutes {\n  min-width: 0.75em;\n  font-family: GothamXNarrow-Medium;\n}\n\n.hours {\n  composes: item;\n  padding-left: 0.938em;\n  font-family: GothamXNarrow-Medium;\n}\n\n.compactRow {\n  font-size: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `tableRows_root_qWzzX`,
	"inset": `tableRows_inset_kHSAz`,
	"a3root": `tableRows_a3root_tgiue`,
	"item": `tableRows_item_Wga4R`,
	"minutes": `tableRows_minutes_OYTai`,
	"hours": `tableRows_hours_ZTGuY tableRows_item_Wga4R`,
	"compactRow": `tableRows_compactRow__moSu`
};
module.exports = ___CSS_LOADER_EXPORT___;
